import { CalendarEventStatus } from '../types';
import { IconCircleCheckFilled, IconHelpCircleFilled, IconInfoCircle } from '@tabler/icons-react';
import { ThemeIcon } from '@mantine/core';

const CalendarEventStatusIcon: React.FC<{ status: CalendarEventStatus | null }> = ({ status }) => {
  if (!status) return null;
  const iconStyle = { flexShrink: 0 };

  switch (status) {
    case CalendarEventStatus.READY:
      return (
        <ThemeIcon size={18} color="green" style={iconStyle} variant="white">
          <IconCircleCheckFilled />
        </ThemeIcon>
      );
    case CalendarEventStatus.SCHEDULED:
      return (
        <ThemeIcon size={18} color="blue" style={iconStyle} variant="white">
          <IconInfoCircle />
        </ThemeIcon>
      );
    case CalendarEventStatus.COMPLETED:
      return (
        <ThemeIcon size={18} color="gray" style={iconStyle} variant="white">
          <IconCircleCheckFilled />
        </ThemeIcon>
      );

    // NOT_READY
    default:
      return (
        <ThemeIcon size={18} color="red" style={iconStyle} variant="white">
          <IconHelpCircleFilled />
        </ThemeIcon>
      );
  }
};

export default CalendarEventStatusIcon;
